import React, { useState, useEffect, useRef } from 'react';
import PerformanceChart from './performance-chart';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import EmptyState from '../../empty-state';
import './performance-chart.m.css';

const PerformanceSection = ({ data, pmKisanList, isHindi, darkMode = false }) => {
  //  toggle support
  const hasToggle = Array.isArray(data?.toggleOptions);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedYear, setSelectedYear] = useState(pmKisanList?.yearsList?.[0]?.value);
  const [isYearOpen, setIsYearOpen] = useState(false);
  const yearRef = useRef(null);

  useEffect(() => {
    setActiveIndex(0);
    setSelectedYear(pmKisanList?.yearsList?.[0]?.value);
  }, [data, pmKisanList]);

  // close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (yearRef.current && !yearRef.current.contains(e.target)) {
        setIsYearOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // decide which data goes to chart
  const chartData = hasToggle
    ? {
        ...data,
        ...data.toggleOptions[activeIndex],
        selectedYear,
      }
    : data;

  const isPMKisanYearly =
    data?.isPMKisanCheck &&
    hasToggle &&
    data.toggleOptions[activeIndex]?.key === pmKisanList?.yearly;

  const selectedYearObj = pmKisanList?.yearsList?.find((y) => y.value === selectedYear);
  const isEmpty =
    !data ||
    !chartData ||
    !chartData['chart-type'] ||
    (Array.isArray(chartData['chart-type']) && chartData['chart-type'].length === 0) ||
    chartData?.data?.length === 0;

  return (
    <div styleName={darkMode ? 'performance dark' : 'performance'}>
      {isEmpty ? (
        <EmptyState height="360px" width="260px" />
      ) : (
        <>
          <div styleName="header-section">
            <div styleName="main-section">
              {chartData?.header && <h2 styleName="heading">{chartData?.header}</h2>}
              {isPMKisanYearly && (
                <div ref={yearRef} styleName="year-dropdown-wrapper">
                  {/* Trigger */}
                  <div
                    styleName="year-dropdown-trigger"
                    onClick={() => setIsYearOpen((prev) => !prev)}
                  >
                    {selectedYearObj?.label || selectedYear}
                    <Icon
                      path={isYearOpen ? mdiChevronUp : mdiChevronDown}
                      size="18px"
                      color="#B7BFC4"
                    />
                  </div>

                  {/* Dropdown List */}
                  {isYearOpen && (
                    <div styleName="year-dropdown-modal">
                      {pmKisanList?.yearsList?.map((item) => (
                        <div
                          key={item.value}
                          styleName={`year-option ${item.value === selectedYear ? 'active' : ''}`}
                          onClick={() => {
                            setSelectedYear(item.value);
                            setIsYearOpen(false);
                          }}
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/*  TOGGLE UI */}
            {hasToggle && (
              <div styleName="toggle">
                {data?.toggleOptions.map((opt, index) => (
                  <button
                    key={opt.key}
                    styleName={`toggleBtn ${index === activeIndex ? 'active' : ''}`}
                    onClick={() => {
                      setActiveIndex(index);
                      setSelectedYear(pmKisanList?.yearsList?.[0]?.value);
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {chartData?.note && (
            <div styleName="note">
              <b>{isHindi ? 'नोट्स' : 'Notes'}:</b> {chartData?.note}
            </div>
          )}

          <PerformanceChart data={chartData} isHindi={isHindi} darkMode={darkMode} />

          {data?.source && (
            <div styleName="source">
              <b>{isHindi ? 'सोर्स' : 'Source'}:&nbsp;</b>
              <span>{data?.source}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PerformanceSection;
